<template>
  <v-autocomplete
    :items="entries"
    :loading="isLoading"
    :search-input.sync="search"
    no-data-text="No results found/loaded yet"
    hide-selected
    outlined
    autocomplete="off"
    color="accent"
    item-text="name"
    item-value="id"
    placeholder="Start typing to find an account"
    prepend-inner-icon="mdi-file-document-box-search-outline"
    return-object
    @change="$emit('selected', $event)"
    clearable
    :label="label"
    no-filter
    v-bind="$attrs"
  >
    <template slot="item" slot-scope="{ item }">
      <span class="body-2"> {{ item.name | title }}</span>
      <strong class="px-2 font-weight-bold">({{ item.short_name }})</strong>
    </template>

    <template slot="selection" slot-scope="{ item }">
      <span class="body-2"> {{ item.name | title }}</span>
      <strong class="px-2 font-weight-bold">({{ item.short_name }})</strong>
    </template>
  </v-autocomplete>
</template>
<script>
import debounce from "lodash/debounce";

export default {
  props: {
    queryFilters: Object,
    label: { default: "Select A currency" },
  },
  data: () => ({
    entries: [],
    isLoading: false,
    search: null,
  }),

  watch: {
    search(value) {
      return this.searchResults(value);
    },
  },
  methods: {
    searchResults: debounce(function (value) {
      if (this.isLoading || !value) return;

      this.isLoading = true;

      // Lazily load input items
      this.$http
        .get(`api/v1/traditionalCurrencies?search=${value}`)
        .then(({ data, total }) => {
          this.count = total;
          this.entries = data;
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          /* eslint-disable*/
          // console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }, 500),
  },
};
</script>
